import { api } from "../BaseConfig";

export const applicantsSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getApplicantsSingleJob: builder.query({
      query: (params) => {
        const searchParams = new URLSearchParams({
          type: params.type,
          job_id: params.id,
          status: params.status,
          date_from: params.date_from ?? "",
          date_to: params.date_to ?? "",
          page: params.page,
        });

        return {
          url: `/${params.acc_type}/view-applicant?${searchParams.toString()}`,
          method: "GET",
          //params,
        };
      },
    }),

    updateAppSingleJob: builder.mutation({
      query: (data) => {
        return {
          url: `/${data.type}/${data.option}-applicant/${data.appId}`,
          method: "POST",
          body: data.values,
        };
      },
    }),
    getActivityJobs: builder.query({
      query: (params) => {
        const searchParams = {
          type: params.type,
          status: params.status,
          date_from: params.date_from ?? "",
          date_to: params.date_to ?? "",
          page: params.page,
        };
        return {
          url: `/individual/view-application`,
          method: "GET",
          params: searchParams,
        };
      },
    }),
    fillTimeSheet: builder.mutation({
      query: (data) => {
        return {
          url: `/individual/fill-timesheet`,
          method: "POST",
          body: data,
        };
      },
    }),
    getApplicant: builder.query({
      query: (params) => ({
        url: `/${params.type}/view-individual/${params.id}`,
        method: "GET",
      }),
    }),
    addComplain: builder.mutation({
      query: ({ type, ...rest }) => {
        return {
          url: `/${type}/add-complain`,
          method: "POST",
          body: rest,
        };
      },
    }),
    completeApplicantJob: builder.mutation({
      query: ({ type, ...rest }) => {
        return {
          url: `/${type}/completed-applicant`,
          method: "POST",
          body: rest,
        };
      },
    }),
    declineApplicantJob: builder.mutation({
      query: ({ acc_type, appId, ...rest }) => {
        return {
          url: `/${acc_type}/decline-applicant/${appId}`,
          method: "POST",
          body: rest,
        };
      },
    }),
    resolveComplaint: builder.mutation({
      query: (data) => {
        return {
          url: `/${data.type}/resolve-complain`,
          method: "POST",
          body: data.values,
        };
      },
    }),
    ratingJob: builder.mutation({
      query: ({ type, ...rest }) => {
        return {
          url: `/${type}/rate-job`,
          method: "POST",
          body: rest,
        };
      },
    }),
  }),
});

export const {
  useGetApplicantsSingleJobQuery,
  useUpdateAppSingleJobMutation,
  useGetActivityJobsQuery,
  useFillTimeSheetMutation,
  useGetApplicantQuery,
  useAddComplainMutation,
  useCompleteApplicantJobMutation,
  useDeclineApplicantJobMutation,
  useResolveComplaintMutation,
  useRatingJobMutation,
} = applicantsSlice;
